import TextareaArrayField from './TextareaArrayField.component';

export default TextareaArrayField;